// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".plv-iar-welfare-lottery__question-statistics{text-align:center;display:flex;flex-direction:column;justify-content:center;align-items:center;width:25%;margin-bottom:28px;font-size:14px}.plv-iar-welfare-lottery__question-statistics .plv-iar-welfare-lottery__question-statistics-title{padding:2px 0}.plv-iar-welfare-lottery__question-statistics-icon img{margin-top:8px;width:20px;height:20px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
